import React from "react";
import Skeleton from "react-loading-skeleton";

function CategorySkeleton() {
  const categoryCard = `rounded-[1.5rem]	relative flex justify-center items-center cursor-pointer cat-wrapper w-full  undefined xl:rounded-[2rem] lg:rounded-[1.5rem] rounded-[1rem]  relative`;
  const contentFull = `w-full h-full`;
  return (
    <>
      <Skeleton
        height={140}
        containerClassName={`${categoryCard}   `}
        className={`${contentFull} pt-[100%]  `}
        borderRadius={`${2}rem`}
      />
      <Skeleton
        containerClassName={`${categoryCard}  `}
        className={`${contentFull} pt-[100%]  `}
        borderRadius={`${2}rem`}
        height={140}
      />
      <Skeleton
        height={140}
        containerClassName={`${categoryCard}  `}
        className={`${contentFull} pt-[100%] `}
        borderRadius={`${2}rem`}
      />
      <Skeleton
        height={140}
        containerClassName={`${categoryCard}  `}
        className={`${contentFull} pt-[100%] `}
        borderRadius={`${2}rem`}
      />
      <Skeleton
        height={140}
        containerClassName={`${categoryCard}  `}
        className={`${contentFull} pt-[100%] `}
        borderRadius={`${2}rem`}
      />
      <Skeleton
        height={140}
        containerClassName={`${categoryCard}  `}
        className={`${contentFull} pt-[100%] `}
        borderRadius={`${2}rem`}
      />
      <Skeleton
        height={140}
        containerClassName={`${categoryCard}  `}
        className={`${contentFull} pt-[100%] `}
        borderRadius={`${2}rem`}
      />
    </>
  );
}

export default CategorySkeleton;
